import { StyleSheet, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Color, Radius, Spacing } from 'zens-storybook'
import { Draft, UserData, useStore, useUserMutation } from 'zens-store'
import { observer } from 'mobx-react'
import { Suspense } from 'react'
import { useRouter, useNumberParams } from 'zens-router'
import { UserHeader, UserForm, LayoutHeader } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.L,
    padding: Spacing.L,
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
  },
})

const UserEdit = () => {
  const [{ userId, companyId }] = useNumberParams()
  const router = useRouter()
  const { message } = useStore()
  const { t } = useTranslation()
  const mutation = useUserMutation({ companyId })

  const save = async (draft: Draft<UserData>) => {
    try {
      await mutation.update(draft)
      message.add({
        message: t('Changes were succesfully saved'),
        status: 'success',
      })
      router.push(`/companies/${companyId}/users`)
    } catch (error) {
      const { message: errorMessage } = error as Error
      console.debug(`USER: User save failed: ${errorMessage}`)
      message.add({
        message: `${t('User could not be saved')}. ${errorMessage}`,
        status: 'error',
      })
    }
  }

  return (
    <View style={styles.container}>
      <Suspense fallback={<LayoutHeader.Skeleton title breadcrumb />}>
        <UserHeader
          companyId={companyId}
          userId={userId}
          breadcrumbItems={[{ title: t('Edit') }]}
          title={t('User details')}
        />
      </Suspense>
      <View style={styles.content}>
        <Suspense fallback={<UserForm.Skeleton />}>
          <UserForm companyId={companyId} userId={userId} onSave={save} />
        </Suspense>
      </View>
    </View>
  )
}

export default observer(UserEdit)
